import { AvariasTipoFerramenta } from '../../models/avariatipoferramenta.model';
import { Component, EventEmitter, Input, OnInit, Output, ViewContainerRef } from '@angular/core';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { CustomMessagesService } from 'src/app/services/custom-messages.service';
import { MessageService } from '@progress/kendo-angular-l10n';
import { DialogContentBase, DialogRef, DialogService } from '@progress/kendo-angular-dialog';
import { NotificationService } from '@progress/kendo-angular-notification';
import { ApiService } from 'src/app/services/http/api.service';
import { BaseHttpResponse, BaseHttpResult } from 'src/app/models/base-http-response';
import { EquipaTipoFerramenta } from 'src/app/models/equipatipoferramenta.model';
import { AddEvent, CancelEvent, CellClickEvent, CellCloseEvent, GridComponent, RemoveEvent, SaveEvent, SelectableSettings } from '@progress/kendo-angular-grid';
import { Keys } from '@progress/kendo-angular-common';

@Component({
  selector: 'app-teams-type-form.component',
  templateUrl: './teams-type-form.component.html'
})
export class EquipaTypeFormComponent extends DialogContentBase implements OnInit {
  public container: ViewContainerRef | undefined;

  setFormValues() {
    this.mySelection = [];
    this.api
      .getRequest<BaseHttpResponse<EquipaTipoFerramenta[]>>("Equipa/GetTipoDeEquipaFerramenta?refEquipa=" + this.idEquipa)
      .then((data) => {
        this.gridData = data.value;
        this.gridView = this.gridData;

        this.mySelection = this.gridData.filter(element => {
          return (element.id != 0);

        }).map(({ refTipoFerramenta }) => refTipoFerramenta);


      })
      .catch((err) => { });
  }

  active: boolean = false;
  public customMsgService: CustomMessagesService = new CustomMessagesService;
  constructor(
    public msgService: MessageService,
    private notificationService: NotificationService,
    private api: ApiService,

    private dialogService: DialogService,
    public override dialog: DialogRef, private formBuilder: FormBuilder,) {
    super(dialog);
    this.customMsgService = this.msgService as CustomMessagesService;
  }
  public formGroup: FormGroup = new FormGroup({});
  public gridData: EquipaTipoFerramenta[] = [];
  public gridView: any[] = [];

  ngOnInit() {
  }

  public mySelection: number[] = [];
  public selectableSettings: SelectableSettings = {
    enabled: true,
    checkboxOnly: true
  };
  public editForm: FormGroup = new FormGroup({
  });
  @Input() public idEquipa = 0;
  @Input() public set model(product: AvariasTipoFerramenta) {
    this.editForm.reset(product);
    this.active = product !== undefined;
  }
  public onSave(e: PointerEvent): void {
    e.preventDefault();
    this.active = false;
  }

  public onCancel(e: PointerEvent): void {
    e.preventDefault();
    this.closeForm();
  }

  public closeForm(): void {
    this.active = false;
  }

  public InfoButton(): void {
    const dialog: DialogRef = this.dialogService.open({
      appendTo: this.container,
      title: this.customMsgService.translate('info'),
      content: this.customMsgService.translate('infoFerramentasAutorizadas'),
      width: 450,
      height: 120,
      minWidth: 250,
    });
  }

  public saveChanges(): void {

    var list = this.gridData.filter(element => {
      return (element.numeroDeFerramentasAutorizadas > 0 || element.id != 0);

    });
    var data = {
      listaTiposAssociados: list,
      refEquipa: this.idEquipa
    };

    this.api.save<BaseHttpResult>('Equipa/SaveEquipaTiposDeFerramenta', data).then(res => {
      if (res.ok) {
        this.notificationService.show({
          content: this.customMsgService.translate('registoGravadoComSucesso'),
          animation: { type: 'slide', duration: 500 },
          position: { horizontal: 'center', vertical: 'bottom' },
          type: { style: 'success', icon: true },
          hideAfter: 2000
        });
        this.dialog.close();
      } else {
      }
    });
  }
  public Toogle(): void {
    this.formGroup.markAsDirty();
  }

  public cellClickHandler(args: CellClickEvent): void {
    if (!args.isEdited) {
      args.sender.editCell(
        args.rowIndex,
        args.columnIndex,
        this.createFormGroup(args.dataItem)
      );
    }
  }

  public cellCloseHandler(args: CellCloseEvent): void {
    const { formGroup, dataItem } = args;
    if (!formGroup.valid) {
      args.preventDefault();
    }
    else if (formGroup.dirty) {
      if (args.originalEvent && args.originalEvent.keyCode === Keys.Escape) {
        return;
      }
      dataItem.numeroDeFerramentasAutorizadas = formGroup.controls['numeroDeFerramentasAutorizadas'].value;
    }
  }

  public cancelHandler(args: CancelEvent): void {
    args.sender.closeRow(args.rowIndex);
  }

  public saveHandler(args: SaveEvent): void {
    if (args.formGroup.valid) {
      args.sender.closeRow(args.rowIndex);
    }
  }

  public removeHandler(args: RemoveEvent): void {
    args.sender.cancelCell();
  }

  public applyChanges(grid: GridComponent): void {
    grid.closeCell();
    grid.cancelCell();
  }

  public cancelChanges(grid: GridComponent): void {
    grid.cancelCell();
  }

  public createFormGroup(dataItem: EquipaTipoFerramenta): FormGroup {
    return this.formBuilder.group({
      numeroDeFerramentasAutorizadas: [
        dataItem.numeroDeFerramentasAutorizadas,
        Validators.compose([
          Validators.required,
          Validators.pattern("^[0-9]{1,3}"),
          Validators.max(dataItem.numeroDeFerramentasDoTipo),
          Validators.min(0)
        ]),
      ],
    });
  }
}
